import axios from "axios"
import { CFDI_ENDPOINT } from "../../../../../utility/SourceAPI"

//Archivo (xml o pdf) de un CFDI como Blob; quien lo pide decide si lo muestra o lo descarga
export const fetchInvoiceFile = async (folioFiscal, fileType) => {
    const response = await axios.get(CFDI_ENDPOINT.concat(`get-file/?folio_fiscal=${folioFiscal}&file_type=${fileType}`), { responseType: 'blob' })
    return response.data
}
